<script setup>
import useSliders from "../../use/useSliders"
import { onUpdated, defineProps, ref, defineEmits } from "vue"

const props = defineProps({
  modelValue: Boolean,
  slider: {
    required: true,
    type: Object,
  },
})

const sliderData = ref({
  id: props.slider.id,
  slider_title: props.slider.slider_title,
  slider_link: props.slider.slider_link,
  slider_priority: props.slider.slider_priority,
  status: props.slider.status,
  slider_image: props.slider.slider_image,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useSliders(
  props,
  emit,
  sliderData
)

onUpdated(() => {
  sliderData.value = {
    id: props.slider.id,
    slider_title: props.slider.slider_title,
    slider_link: props.slider.slider_link,
    slider_priority: props.slider.slider_priority,
    status: props.slider.status,
    slider_image: props.slider.slider_image,
  }
})

const onFileChange = (event) => {
  sliderData.value.slider_image = event.target.files[0]
}
</script>

<template>
  <!-- add slider modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="افزودن اسلایدر"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="title" class="form-label">عنوان اسلاید</label>
            <input
              type="text"
              id="title"
              class="form-control"
              placeholder="عنوان اسلاید"
              v-model="sliderData.slider_title"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.slider_title">
                <span>{{ errors.slider_title[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="link" class="form-label">لینک اسلاید</label>
            <input
              type="text"
              id="link"
              class="form-control"
              placeholder="لینک اسلاید"
              v-model="sliderData.slider_link"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.slider_link">
                <span>{{ errors.slider_link[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="priority" class="form-label">اولویت اسلاید</label>
            <input
              type="number"
              id="priority"
              class="form-control"
              placeholder="اولویت اسلاید"
              v-model="sliderData.slider_priority"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.slider_priority">
                <span>{{ errors.slider_priority[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="formFile" class="form-label">تصویر</label>
            <input
              class="form-control"
              type="file"
              id="formFile"
              @change="onFileChange"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.slider_image">
                <span>{{ errors.slider_image[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="status-slider" class="form-label">وضعیت نمایش</label>
            <select
              class="form-select"
              id="status-slider"
              v-model="sliderData.status"
            >
              <option selected>وضعیت</option>
              <option value="0">عدم نمایش</option>
              <option value="1">نمایش</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">افزودن اسلایدر</b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
